/*
*
* File JS componente Text Map
*
*/


// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import ScrollMagic from 'ScrollMagic';
// import 'debug.addIndicators';

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './text-map.scss';

//--------------------------------------------------------------------//


// JS SPECIFICO COMPONENTE
//--------------------------------------------------------------------//

const manageAnimation = () => {
    let triggerEl = document.querySelector('.block-textmap');

    if (!triggerEl) return;

    let sceneHero = null;
    let controller = new ScrollMagic.Controller();
    let durationScene = window.innerHeight;

    let mapWithPin = triggerEl.querySelector('.block-textmap__media-pin');
    let allImg = triggerEl.querySelectorAll('.block-textmap__media img');

    sceneHero = new ScrollMagic.Scene({
        triggerElement: triggerEl,
        offset: durationScene * 2,
        triggerHook: 1,
        duration: durationScene
    })
    // .addIndicators()
    .on('progress', function(evt){
        
        mapWithPin.style.opacity = evt.progress;

        if (!allImg.length) return;

        allImg.forEach(el => {
            el.style.transform = `scale(${0.6 + evt.progress})`;
        });
    })
    .addTo(controller);
}

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const textMap = () => {

    manageAnimation();

}

export default textMap;

//--------------------------------------------------------------------//